import { useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

export const useSelectedEnvelope = () => {
  const { search } = useLocation();
  const [searchParams] = useSearchParams(search);

  const selectedEnvelope = useMemo(() => searchParams.get('envelope'), [searchParams]);

  return { selectedEnvelope };
};
